import React, { useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import { NavLink } from "react-router-dom";
import { productionOrderStates as state } from '../../../../Config/productionOrderStates'
import Popover from '@material-ui/core/Popover';
import ChangeStatePopoverContent from '../../../Shared/ChangeStatePopoverContent';
import TakeSampleDialog from '../../../Shared/Dialogs/TakeSampleDialog';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import NewBookingDialog from '../../../Shared/Dialogs/NewBookingDialog';
import FinishOrderDialog from '../../../Shared/Dialogs/FinishOrderDialog'
import StopOrderDialog from '../../../Shared/Dialogs/StopOrderDialog';
import { generateNewId } from '../../../../Helpers/generalHelper'
import { dataService } from '../../../../Services/data.service'
import { toast } from 'react-toastify';
import Timer from '../../../Shared/Timer';
import { useHistory } from 'react-router-dom';
import { Reply } from '@material-ui/icons';
import AlertDialog from '../../../Shared/Dialogs/AlertDialog';
import ClientCommentsDialog from '../../../Shared/Dialogs/ClientCommentsDialog';
import PDFDialog from '../../../Shared/Dialogs/PDFDialog';

export default function OrderDetailStatusBar(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    let history = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);
    const [sampleDialogOpen, setSampleDialogOpen] = useState(false);
    const [newBookingDialogOpen, setNewBookingDialogOpen] = useState(false);
    const [jobCompleteDialogOpen, setJobCompleteDialogOpen] = useState(false)
    const [stopOrderDialogOpen, setStopOrderDialogOpen] = useState(false)
    const [clientCommentsDialogOpen, setClientCommentsDialogOpen] = useState(false)
    const [barcode, setBarcode] = useState(null);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);
    const [wrongBarcodeDialogOpen, setWrongBarcodeDialogOpen] = useState(false)
    const [pdfDialogOpen, setPdfDialogOpen] = useState(false);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let stateIcon = <React.Fragment></React.Fragment>;
    let stateBackgroundColor = ""

    switch (props.productionOrder.productionOrderStatus) {
        case state.RUNNING:
            stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
            stateBackgroundColor = "rgb(92, 201, 88,0.28)"
            break;
        case state.PAUSED:
            stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
            stateBackgroundColor = "rgb(245, 145, 40,0.28)"
            break;
        case state.STOPPED:
            stateIcon = <div className={classes.stop}></div>;
            stateBackgroundColor = "rgb(216, 73, 73,0.28)"
            break;
        case state.PLANNED:
            stateIcon = <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>;
            stateBackgroundColor = "rgb(2, 1, 0,0.28)"
            break;
        case state.DONE:
            stateIcon = <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>;
            stateBackgroundColor = "rgb(92, 201, 88,0.28)"
            break;
        default:
    }

    const openNewBookingDialog = () => {

        if (props.checkQuantitiesAtMachineBeforeBookingOrStarting()) {
            setDialogTitle(t("New booking"))
            let totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier)
            let progress = 1
            if (props.producedBOMOut) {
                progress = Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier) + 1
            }
            setDialogContext("Pallet " + progress + "/" + totalPallets)
            setNewBookingDialogOpen(true)
        }
    }

    const newBooking = (stackingHeight, paletNumber) => {

        let totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier)
        let progress = 1
        if (props.producedBOMOut) {
            progress = Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier) + 1
        }

        dataService.createBookingForProductionOrder(props.productionOrder, paletNumber, progress).then(
            reply => {
                if (checkBookingReply(reply, paletNumber)) {
                    if (progress === totalPallets) {
                        dataService.finishProductionOrder(props.productionOrder.id).then(setTimeout(() => { props.refreshOrder(); }, 3000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
                        setDialogTitle(t("Job complete"))
                        setJobCompleteDialogOpen(true)
                    }
                }
                setTimeout(() => { props.refreshOrder(); }, 3000)
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        setNewBookingDialogOpen(false)
    }

    const changeOrderState = (orderState) => {

        if (orderState === state.STOPPED) {
            setAnchorEl(null)
            setDialogTitle(t("Are you sure to stop?"))
            setDialogContext(t("This can not be made undone!"))
            setStopOrderDialogOpen(true)
        }
        else if (orderState === state.PAUSED) {
            dataService.pauseProductionOrder(props.productionOrder.id).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            setAnchorEl(null)
        }
        else if (orderState === state.RUNNING) {
            dataService.startProductionOrder(props.productionOrder.id).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            setAnchorEl(null)
        }
    }

    const stopOrder = () => {
        dataService.stopProductionOrder(props.productionOrder.id).then(setTimeout(() => { props.refreshOrder(); }, 2000)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    const checkBookingReply = (reply, barcode) => {
        if (!reply.succeeded && reply.messages[0].includes('Error2')) {
            setDialogTitle(t("Wrong barcode!"))
            setDialogContext(t("Given barcode ") + barcode + t(" is not assigned to production order ") + props.productionOrder.reference)
            setWrongBarcodeDialogOpen(true)
            return false
        }
        else if (!reply.succeeded && reply.messages[0].includes('Error3')) {
            setDialogTitle(t("Pallet already booked!"))
            setDialogContext(t("Pallet with barcode ") + barcode + t(" is already booked for production order ") + props.productionOrder.reference)
            setWrongBarcodeDialogOpen(true)
            return false
        }

        return true
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const openPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const openWorkingInstructionsPdfDialog = () => {
        setDialogTitle("")
        setDialogContext("")
        setPdfDialogOpen(true)
    }

    const closePdfDialog = () => {
        setPdfDialogOpen(false)
    }

    const takeSample = () => {
        setDialogTitle(t("Take a sample") + "!")
        if (props.workstation.selectedZone) {
            setDialogContext(t("PLATE measurement from LINE ") + props.productionOrder.machinePlannedCode + " zone " + props.workstation.selectedZone)
        }
        else {
            setDialogContext(t("PLATE measurement from LINE ") + props.productionOrder.machinePlannedCode)
        }

        setSampleDialogOpen(true)
    };

    const closeSampleDialog = () => {
        setSampleDialogOpen(false)
    }

    const performTest = (palletnumber, progress) => {
        history.push('/sampling/' + props.productionOrder.id + '/' + palletnumber + "/" + progress + "/0")
    };

    let pausedOrRunning = props.productionOrder.productionOrderStatus === state.RUNNING || props.productionOrder.productionOrderStatus === state.PAUSED
    let doneOrStopped = props.productionOrder.productionOrderStatus === state.DONE || props.productionOrder.productionOrderStatus === state.STOPPED
    let planned = props.productionOrder.productionOrderStatus === state.PLANNED
    let piecesPerPallet = props.productionOrder.bomOut[0].quantityOnCarrier
    let authorized = props.productionOrder.machineIdPlanned === props.workstation.selectedWorkstation
    let progress = 0;
    let comments = ""
    if (props.productionOrder) {
        comments = JSON.parse(props.productionOrder.metaData).find(y => y.MetaDataType === 2).MetaData[0].ClientComments
    }

    if (props.producedBOMOut) {
        progress = Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier)
    }

    return <React.Fragment>
        <div className={classes.stateContainer} style={{ backgroundColor: stateBackgroundColor }}>
            <button className={classes.popoverButton} onClick={pausedOrRunning && authorized ? (e) => openPopover(e) : planned && authorized ? () => props.openOrderDetailStateDrawer(true) : null} style={{ cursor: ((pausedOrRunning || planned) && authorized) && "pointer" }}>
                <div className={classes.centerState} style={{ paddingLeft: doneOrStopped ? "50px" : "0px" }}>
                    <div className={classes.icon}>{stateIcon}</div>
                    <div className={classes.stateElapsed} >
                        <div className={classes.state} style={{ marginTop: pausedOrRunning ? "0px" : props.productionOrder.productionOrderStatus === state.STOPPED ? "4px" : "6px" }}>{t(props.productionOrder.productionOrderStatus)}</div>
                        {pausedOrRunning ? <div className={classes.elapsed}><Timer startTime={props.productionOrder.startedOn} {...props}></Timer></div> : <React.Fragment></React.Fragment>}
                    </div>
                    {pausedOrRunning && authorized ? <ExpandMoreIcon className={classes.expandStatesIcon}></ExpandMoreIcon> : planned && authorized ? <KeyboardArrowRightIcon className={classes.expandStatesIcon}></KeyboardArrowRightIcon> : <React.Fragment></React.Fragment>}
                </div>
            </button>
        </div>
        {props.productionOrder.productionOrderStatus === state.DONE || props.productionOrder.productionOrderStatus === state.STOPPED || props.productionOrder.productionOrderStatus === state.PLANNED || !authorized ? <React.Fragment></React.Fragment> : <div className={classes.newBooking}>
            <button className={classes.newBookingButton} onClick={() => openNewBookingDialog()}>
                <div className={classes.newBookingText} >{t('NEW BOOKING')}</div>
            </button>
        </div>}
        {!planned && authorized ? <div className={classes.actions}>
            <div className={classes.action}>
                <button className={classes.actionButton} onClick={() => takeSample()}>
                    <div className={classes.actionText}>
                        {t('TakeASample')}
                    </div>
                </button>
            </div>
            <div className={classes.action}>
                <NavLink className={classes.navButton} to={`/qualitychecks/${progress}/${encodeURIComponent(props.productionOrder.id)}/`}>
                    <button className={classes.actionButton}>
                        <div className={classes.actionText}>
                            {t('QualityChecks')}
                        </div>
                    </button>
                </NavLink>
            </div>
            {pausedOrRunning && authorized ?
                <div className={classes.action}>
                    <button className={classes.actionButton} onClick={() => props.openMachineParametersDrawer(true)}>
                        <div className={classes.actionText}>
                            {t('MachineParameters')}
                        </div>
                    </button>
                </div>
                : <React.Fragment></React.Fragment>}
            <div className={classes.action}>
            <button className={classes.actionButton} onClick={() => openWorkingInstructionsPdfDialog()}>
                <div className={classes.actionText}>
                    {t('WorkInstructions')}
                </div>
            </button>
        </div>
            <div className={classes.action}>
                <button className={classes.actionButton} onClick={() => props.openTransportOrdersDrawer(true)}>
                    <div className={classes.actionText}>
                        {t('TransportOrders')}
                    </div>
                </button>
            </div>
        </div>
            :
            <React.Fragment></React.Fragment>}
        {comments === "" || comments === null ?
            <React.Fragment></React.Fragment>
            :
            <div className={classes.clientCommentsContainer} style={{ height: pausedOrRunning ? "59%" : planned ? "87%" : "72%" }}>
                <div className={classes.clientCommentsTitle}>
                    {t("Client comments")}
                </div>
                <div className={classes.clientComments}>
                    {comments.length > 400 ? comments.substring(0, 400)
                        :
                        comments}
                </div>
                {comments.length > 400 ?
                    <div className={classes.showMoreButtonContainer}>
                        <button className={classes.showMoreButton} onClick={() => setClientCommentsDialogOpen(true)}>
                            {t("SHOW MORE")}
                        </button>
                    </div>

                    :
                    <React.Fragment></React.Fragment>}
            </div>}
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <ChangeStatePopoverContent state={props.productionOrder.productionOrderStatus} changeState={changeOrderState} popoverWidth={"15vw"}></ChangeStatePopoverContent>
        </Popover>
        <PDFDialog {...props} workingInstructions = {true} dialogOpen={pdfDialogOpen} closeDialog={closePdfDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></PDFDialog>
        <AlertDialog dialogOpen={wrongBarcodeDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setWrongBarcodeDialogOpen(false)} action={() => setWrongBarcodeDialogOpen(false)}></AlertDialog>
        <FinishOrderDialog {...props} producedBOMOut={props.producedBOMOut} dialogOpen={jobCompleteDialogOpen} action={() => setJobCompleteDialogOpen(false)} dialogTitle={dialogTitle} dialogContext={dialogContext} piecesPerPallet={piecesPerPallet} closeDialog={() => setJobCompleteDialogOpen(false)}></FinishOrderDialog>
        <NewBookingDialog {...props} dialogOpen={newBookingDialogOpen} action={newBooking} closeDialog={() => setNewBookingDialogOpen(false)} dialogTitle={dialogTitle} dialogContext={dialogContext}></NewBookingDialog>
        <StopOrderDialog {...props} producedBOMOut={props.producedBOMOut} dialogOpen={stopOrderDialogOpen} action={stopOrder} dialogTitle={dialogTitle} dialogContext={dialogContext} piecesPerPallet={piecesPerPallet} closeDialog={() => setStopOrderDialogOpen(false)} ></StopOrderDialog>
        <ClientCommentsDialog {...props} comments={comments} dialogOpen={clientCommentsDialogOpen} closeDialog={() => setClientCommentsDialogOpen(false)}></ClientCommentsDialog>
        <TakeSampleDialog {...props} progress={progress} closeDialog={() => closeSampleDialog()} dialogOpen={sampleDialogOpen} action={performTest} dialogTitle={dialogTitle} dialogContext={dialogContext} piecesPerPallet={piecesPerPallet}></TakeSampleDialog>
    </React.Fragment>
}

const useStyles = makeStyles({
    play: {
        color: "#5CC958",
        height: "50px",
        width: "50px"
    },
    stop: {
        height: "25px",
        width: "25px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "45px",
        width: "45px",
        color: "#F59127",
        marginLeft: "5px"
    },
    planned: {
        height: "35px",
        width: "35px",
        marginTop: "5px",
        marginRight: "10px"
    },
    done: {
        height: "35px",
        width: "35px",
        marginTop: "5px",
        marginRight: "10px"
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    icon: {
        float: "left",
    },
    state: {
        textTransform: "uppercase",
        fontSize: "17px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block"
    },
    stateElapsed: {
        float: "left",
        marginLeft: "5px",
        marginTop: "5px"
    },
    elapsed: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block"
    },
    stateContainer: {
        width: "100%",
        height: "80px",
        paddingTop: "40px",
        textAlign: "center"
    },
    centerState: {
        height: "40px",
        marginRight: "auto",
        marginLeft: "auto",
        width: "220px"
    },
    changeButton: {
        width: "86%",
        marginTop: "15px",
        marginLeft: "7%",
        marginRight: "7%",
        height: "40px",
        borderRadius: "6px",
        padding: "0px",
        border: "none",
        outline: "none",
        cursor: "pointer",
    },
    changePlay: {
        color: "white",
    },
    changePause: {
        color: "white",
    },
    changeText: {
        color: "white",
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "5px",
        paddingTop: "8px"
    },
    changeArrow: {
        float: "right",
    },
    expandStatesIcon: {
        float: "left",
        marginTop: "10px",
        marginLeft: "10px",
        color: FlagstoneTheme.palette.primary.main
    },
    changeIcon: {
        float: "right",
        padding: "5px",
        paddingRight: "0px"
    },
    changeArrowIcon: {
        paddingTop: "5px",
        paddingRight: "5px",
        height: "25px",
        width: "25px",
        fill: "white"
    },
    newBookingButton: {
        width: "86%",
        marginTop: "20px",
        marginLeft: "7%",
        marginRight: "7%",
        marginBottom: "10px",
        height: "40px",
        borderRadius: "6px",
        padding: "0px",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        border: "none",
        outline: "none",
        cursor: "pointer",
    },
    newBookingText: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "5px",
    },
    actions: {
        width: "100%",
        height: "auto",
        padding: "7%",
        paddingTop: "20px",
        boxSizing: "border-box"
    },
    action: {
        backgroundColor: "#4654FB22",
        height: "40px",
        widht: "100%",
        borderRadius: "5px",
        marginBottom: "5px",
    },
    actionText: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: FlagstoneTheme.palette.primary.main,
        textTransform: "none",
        width: "100%",
        textAlign: "center"

    },
    actionButton: {
        paddingLeft: "0px",
        width: "100%",
        border: "none",
        outline: "none",
        cursor: "pointer",
        paddingTop: "12px",
        paddingBottom: "7px",
        backgroundColor: "transparent",
    },
    popoverButton: {
        border: "none",
        outline: "none",
        backgroundColor: "rgba(1,1,1,0)"
    },
    clientCommentsContainer: {
        backgroundColor: "#FFF8DB",
        width: "100%",
        padding: "7%",
        boxSizing: 'border-box'
    },
    clientCommentsTitle: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    clientComments: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        marginTop: "7%"
    },
    showMoreButtonContainer: {
        width: "100%",
        textAlign: "center"
    },
    showMoreButton: {
        width: "120px",
        height: "40px",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: FlagstoneTheme.palette.primary.main,
        backgroundColor: "#FFF8DB",
        cursor: "pointer",
        border: "none",
        outline: "none",
        marginTop: "20px"
    }


});